import { Component, inject } from '@angular/core';
import { UnauthPageIntroComponent } from '../../components/unauth-page-intro/unauth-page-intro.component';
import { UnauthenticatedPageComponent } from '../../components/unauthenticated-page/unauthenticated-page.component';
import { UnauthenticatedForwardNavService } from '../../services/unauthenticated-forward-nav.service';

@Component({
  selector: 'app-about-how-it-works-manager',
  standalone: true,
  imports: [UnauthenticatedPageComponent, UnauthPageIntroComponent],
  templateUrl: './about-how-it-works-manager.component.html',
  styleUrl: './about-project.component.css',
})
export class AboutHowItWorksManagerComponent {
  readonly unauthNav = inject(UnauthenticatedForwardNavService);
  readonly pageTitle = 'How CrowdCTRL Manager works';
}
